<template>
    <div>
        <a :href="button.href" target="_blank">
            <img :src="button.image" alt="dappBadge">
        </a>
    </div>
</template>

<script>

export default {
    name: 'DappBadgeButton',
    props: {
        button: {
            type: Object,
            required: true
        }
    }
};
</script>
